import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { OrganizationEndpoint } from '../constants/organization-endpoint';
import { OrganizationItemModel, OrganizationModel } from '../models';

@Injectable({
  providedIn: 'root',
})
export class OrganizationItemService {
  constructor(private http: WrapperHttpService) {}

  getOrganizationDetails(organizationId: string): Observable<OrganizationModel> {
    return this.http.withLoading().get<OrganizationModel>(`${API_URL}${OrganizationEndpoint.Base}/${organizationId}`);
  }

  createOrganization(body: OrganizationItemModel): Observable<OrganizationModel> {
    return this.http.withLoading().post<OrganizationModel>(`${API_URL}${OrganizationEndpoint.Base}`, body);
  }

  updateOrganization(body: OrganizationItemModel): Observable<OrganizationModel> {
    return this.http.withLoading().post<OrganizationModel>(`${API_URL}${OrganizationEndpoint.Base}`, body);
  }

  deleteOrganization(organizationId: string): Observable<void> {
    return this.http.withLoading().delete<void>(`${API_URL}${OrganizationEndpoint.Base}/${organizationId}`);
  }
}
